import { useState, useEffect } from 'react';
import { Modal, ModalOverlay, ModalContent, ModalBody, ModalCloseButton, Image, Flex } from '@chakra-ui/react';
import { CbButton } from 'ui/components';
import { useRoles } from 'hooks/useRoles';
import { userRoleIsAtLeast } from 'helpers/roles';
import { Role } from 'types/Role';
import { useCurrentUser } from 'hooks';
import { useIsEmbedded } from 'providers/MPEmbeddedContextProvider';
const WAITLIST_LINK = 'https://play.arcade.co/join-the-movement';
const COOLDOWN_MS = 3 * 24 * 60 * 60 * 1000; //  3 days

function shouldShowModal(viewedUnificationModalAt: string | null): boolean {
  if (!viewedUnificationModalAt) return true;
  const elapsed = Date.now() - new Date(viewedUnificationModalAt).getTime();
  return elapsed >= COOLDOWN_MS;
}
export const WaitlistModal = () => {
  const userRole = useRoles();
  const currentUser = useCurrentUser();
  const {
    isEmbedded
  } = useIsEmbedded();
  const [isOpen, setIsOpen] = useState(false);
  const hasRequiredRole = userRoleIsAtLeast({
    requiredRole: Role.TeamManager,
    userRole
  });
  useEffect(() => {
    if (!hasRequiredRole || isEmbedded || !currentUser) return;
    if (shouldShowModal(currentUser.viewedUnificationModalAt)) {
      setIsOpen(true);
      currentUser.updateCurrentUser({
        viewedUnificationModalAt: new Date().toISOString()
      });
    }
  }, [hasRequiredRole, isEmbedded, currentUser?.id]);
  if (!isOpen) return null;
  return <Modal isOpen={isOpen} onClose={() => setIsOpen(false)} isCentered closeOnOverlayClick closeOnEsc data-sentry-element="Modal" data-sentry-component="WaitlistModal" data-sentry-source-file="WaitlistModal.tsx">
      <ModalOverlay bg="blackAlpha.700" backdropFilter="blur(4px)" data-sentry-element="ModalOverlay" data-sentry-source-file="WaitlistModal.tsx" />
      <ModalContent maxW="480px" borderRadius="xl" overflow="hidden" p={0} bg="white" data-sentry-element="ModalContent" data-sentry-source-file="WaitlistModal.tsx">
        <ModalCloseButton color="white" bg="blackAlpha.400" borderRadius="full" zIndex={1} _hover={{
        bg: 'blackAlpha.600'
      }} data-sentry-element="ModalCloseButton" data-sentry-source-file="WaitlistModal.tsx" />
        <Image src="/images/waitlist-promo.png" alt="The new Arcade app is coming!" w="100%" objectFit="cover" fallback={<></>} data-sentry-element="Image" data-sentry-source-file="WaitlistModal.tsx" />
        <ModalBody py={6} px={6} data-sentry-element="ModalBody" data-sentry-source-file="WaitlistModal.tsx">
          <Flex direction="column" align="center" data-sentry-element="Flex" data-sentry-source-file="WaitlistModal.tsx">
            <CbButton width="100%" size="lg" onClick={() => window.open(WAITLIST_LINK, '_blank', 'noopener')} data-sentry-element="CbButton" data-sentry-source-file="WaitlistModal.tsx">
              Join the Waitlist!
            </CbButton>
          </Flex>
        </ModalBody>
      </ModalContent>
    </Modal>;
};